import {CSSProperties, ReactNode, useState} from "react";
import {type Cell, flexRender} from "@tanstack/react-table";
import cn from "classnames";

import {CheckIcon, CloseIcon, EditIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";

import {ColumnEditState} from "../types/ColumnEditState";
import {TableCellEditableControls} from "./TableCellEditableControls";

import * as styles from "./TableCell.module.css";

interface IProps<TDataSource> {
    cell: Cell<TDataSource, unknown>;
    style?: CSSProperties;
}

export const TableCell = <TDataSource extends {}>(props: IProps<TDataSource>) => {
    const {cell} = props;

    const [editState, setEditState] = useState(ColumnEditState.NONE);

    const isEditable = !!cell.column.columnDef.editable;
    const editableProps = cell.column.columnDef.editable;
    const value = cell.getValue() as number | string;

    const onEditClick = () => {
        if (editState !== ColumnEditState.SAVING) {
            setEditState(ColumnEditState.EDITING);
        }
    };

    const onSave = (value: number | string) => {
        setEditState(ColumnEditState.SAVING);

        editableProps?.onSave(value as never, cell.getContext()).then(
            () => {
                setEditState(ColumnEditState.DONE);
            },
            () => {
                setEditState(ColumnEditState.FAIL);
            }
        );
    };

    const onCancel = () => {
        setEditState(ColumnEditState.NONE);
        editableProps?.onCancel?.();
    };

    const tableCellRenderer = (): ReactNode => flexRender(cell.column.columnDef.cell, cell.getContext()) as ReactNode;

    const onMouseEnterOnIconWrapper = () => {
        if (editState === ColumnEditState.DONE || editState === ColumnEditState.FAIL) {
            setEditState(ColumnEditState.NONE);
        }
    };

    const size = cell.column.getSize();

    return (
        <td className={styles.cell} style={{...props.style, ...(size ? {width: size} : {})}} data-column={cell.column.id}>
            {isEditable ? (
                <div className={styles.editable} onDoubleClick={onEditClick}>
                    {tableCellRenderer()}

                    {editState === ColumnEditState.EDITING && editableProps ? (
                        <TableCellEditableControls
                            type={editableProps.type}
                            options={editableProps.options}
                            minWidth={editableProps.minWidth}
                            value={value}
                            onSave={onSave}
                            onCancel={onCancel}
                        />
                    ) : null}

                    {editState !== ColumnEditState.EDITING ? (
                        <div
                            className={cn(styles.editIcon, styles.icon, editState === ColumnEditState.NONE && styles.iconNonState)}
                            onMouseEnter={onMouseEnterOnIconWrapper}
                        >
                            {editState === ColumnEditState.NONE ? <EditIcon size="2.4" className={styles.cursorPointer} onClick={onEditClick} /> : null}
                            {editState === ColumnEditState.SAVING ? (
                                <div className={styles.loader}>
                                    <Loader size="sm" />
                                </div>
                            ) : null}
                            {editState === ColumnEditState.DONE ? <CheckIcon size="2.4" fill="var(--colors-success)" /> : null}
                            {editState === ColumnEditState.FAIL ? <CloseIcon size="2.4" fill="var(--colors-danger)" /> : null}
                        </div>
                    ) : null}
                </div>
            ) : (
                tableCellRenderer()
            )}
        </td>
    );
};
import {CSSProperties, ReactNode, useState} from "react";
import {type Cell, flexRender} from "@tanstack/react-table";
import cn from "classnames";

import {CheckIcon, CloseIcon, EditIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";

import {ColumnEditState} from "../types/ColumnEditState";
import {TableCellEditableControls} from "./TableCellEditableControls";

import * as styles from "./TableCell.module.css";

interface IProps<TDataSource> {
    cell: Cell<TDataSource, unknown>;
    style?: CSSProperties;
}

export const TableCell = <TDataSource extends {}>(props: IProps<TDataSource>) => {
    const {cell} = props;

    const [editState, setEditState] = useState(ColumnEditState.NONE);

    const isEditable = !!cell.column.columnDef.editable;
    const editableProps = cell.column.columnDef.editable;
    const value = cell.getValue() as number | string;

    const onEditClick = () => {
        if (editState !== ColumnEditState.SAVING) {
            setEditState(ColumnEditState.EDITING);
        }
    };

    const onSave = (value: number | string) => {
        setEditState(ColumnEditState.SAVING);

        editableProps?.onSave(value as never, cell.getContext()).then(
            () => {
                setEditState(ColumnEditState.DONE);
            },
            () => {
                setEditState(ColumnEditState.FAIL);
            }
        );
    };

    const onCancel = () => {
        setEditState(ColumnEditState.NONE);
        editableProps?.onCancel?.();
    };

    const tableCellRenderer = (): ReactNode => flexRender(cell.column.columnDef.cell, cell.getContext()) as ReactNode;

    const onMouseEnterOnIconWrapper = () => {
        if (editState === ColumnEditState.DONE || editState === ColumnEditState.FAIL) {
            setEditState(ColumnEditState.NONE);
        }
    };

    const size = cell.column.getSize();

    return (
        <td className={styles.cell} style={{...props.style, ...(size ? {width: size} : {})}} data-column={cell.column.id}>
            {isEditable ? (
                <div className={styles.editable} onDoubleClick={onEditClick}>
                    {tableCellRenderer()}

                    {editState === ColumnEditState.EDITING && editableProps ? (
                        <TableCellEditableControls
                            type={editableProps.type}
                            options={editableProps.options}
                            minWidth={editableProps.minWidth}
                            value={value}
                            onSave={onSave}
                            onCancel={onCancel}
                        />
                    ) : null}

                    {editState !== ColumnEditState.EDITING ? (
                        <div
                            className={cn(styles.editIcon, styles.icon, editState === ColumnEditState.NONE && styles.iconNonState)}
                            onMouseEnter={onMouseEnterOnIconWrapper}
                        >
                            {editState === ColumnEditState.NONE ? <EditIcon size="2.4" className={styles.cursorPointer} onClick={onEditClick} /> : null}
                            {editState === ColumnEditState.SAVING ? (
                                <div className={styles.loader}>
                                    <Loader size="sm" />
                                </div>
                            ) : null}
                            {editState === ColumnEditState.DONE ? <CheckIcon size="2.4" fill="var(--colors-success)" /> : null}
                            {editState === ColumnEditState.FAIL ? <CloseIcon size="2.4" fill="var(--colors-danger)" /> : null}
                        </div>
                    ) : null}
                </div>
            ) : (
                tableCellRenderer()
            )}
        </td>
    );
};
